// IMPORT SVG
import React from 'react';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import { animated, useSpring } from 'react-spring';
import styles from './mobileStepIndicator.module.css';

const AnTypography = animated(Typography);
const AnBox = animated(Box);

export interface MobileStepIndicatorProps {
  totalStep: number;
  step: number;
  fullwidth?: boolean;
}

export const MobileStepIndicator = (
  props: MobileStepIndicatorProps,
): JSX.Element => {
  return (
    <React.Fragment>
      <Box
        className={`${styles.mainBox} ${
          props.fullwidth ? styles.fullwidth : undefined
        }`}
      >
        {_.times(props.totalStep, (i) => {
          return <StepRectangular filled={i + 1 === props.step} />;
        })}
      </Box>
    </React.Fragment>
  );
};

interface StepRectangularProps {
  filled?: boolean;
}

const StepRectangular = (props: StepRectangularProps) => {
  return (
    <React.Fragment>
      <Box
        className={`${styles.rectangular} ${
          props.filled ? styles.filled : styles.blank
        }`}
      ></Box>
    </React.Fragment>
  );
};
